import React from 'react'
import { IconStyled } from '@/components/Icon/Icon.styled'

export const MyIcon = ({ component, ...props }) => {
	return <IconStyled component={component} {...props}  />
}